<template>
  <v-form @submit.prevent="createOrganization">
    <v-row no-gutters>
      <span class="red--text font-weight-bold">
        {{ formValidator.getError("non_field_errors") }}
      </span>
      <v-col cols="12" class="px-3 py-3">
        <v-text-field
          v-model="formValues.name"
          :error-messages="formValidator.getError('name')"
          counter="255"
          label="Organization Name"
          clearable
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" class="text-right pt-2 px-1 pb-1">
        <v-btn depressed small @click="$emit('close')">
          Go Back
        </v-btn>
        <v-btn
          small
          :disabled="Object.keys(formValidator.errors).length > 0"
          class="primary"
          type="submit"
        >
          Save
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { FormValidator } from "rhr-core-shell";
export default {
  data() {
    return {
      formValues: {},
      formValidator: new FormValidator()
    };
  },
  watch: {
    "formValues.name": {
      handler(val) {
        if (!val) {
          this.formValidator.setError({});
        }
      }
    }
  },
  methods: {
    createOrganization() {
      const endpoint = `/api/v1/org/`;
      this.$axios
        .$post(endpoint, this.formValues)
        .then(() => {
          this.$store.dispatch("shell/showSnackbar", {
            text: `Successfully created organization.`,
            color: "green"
          });
          this.$emit("create");
        })
        .catch(error => {
          this.formValidator.setError(error.response.data);
        });
    }
  }
};
</script>
